// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { fetchPointTransactions } from 'syft-acp-core/api/resources/admin/point-transactions'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('POINT_TRANSACTIONS_FETCH', fetchPointTransactions)
}
